import { useParams} from 'react-router-dom';
import Header from './Header';
import { Box, Container,Typography ,Divider,Chip, Stack} from '@mui/material';
import DashBoard from './DashBoard';
import './videoPage.css'

const VideoPage=({videoList})=>
{
const params = useParams();
const uniqueVideo1=videoList.find((video)=>video._id===params.id);
const { videoLink, title, releaseDate } =uniqueVideo1 ;

 return (
    <>
    <Header></Header>
    <Container maxWidth='lg'>
   <div className="container">
   <iframe className="responsive-iframe" src={`https://www.${videoLink}`} id='ytplayer' frameBorder='0' type='text/html' title={title}></iframe>
   </div>
   <Box sx={{ px: 1, pt: 2 }}>
   <Typography align="left" sx={{color:'#FFFFFF',frontSize:'20px',fontWeight:'700',pb: 1,}} className="videoTitle">{title}</Typography>
   <Box sx={{display: 'flex',alignItems: 'center',justifyContent: 'space-between',}} >
   <Typography align="left" color="text.secondary" sx={{frontSize:'14px',fontWeight:'400'}}>{releaseDate}</Typography>
   <Stack  direction="row" spacing={1}  className='box'>
   <Chip  label="UpVote" variant="outlined" color="secondary" />
   <Chip label="DownVote" variant="outlined" color="secondary" />
   </Stack>
   </Box>
   
    </Box>
    <Divider sx={{ my: 3 }} />
    <DashBoard videoList={videoList}/>
    </Container>
    </>
 )   
}

export default VideoPage;